var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"form-group\" ng-if=\"!sl.isText\"><label class=\"small\">Label <i class=\"fa fa-question-circle text-info\" uib-tooltip=\"Change how this layer is labeled; this has no affect on how the image is rendered\" tooltip-placement=\"right\"></i></label> <input placeholder=\"Provide a label\" ng-model=\"sl.label\" type=\"text\" ng-model-options=\"{ getterSetter: true }\" required class=\"form-control input-md\"/></div>";
var id1="design-layer.label.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;